import { DocumentNode, gql } from '@apollo/client';
import {
  BoxProps,
  HStack,
  LinkBox,
  LinkOverlay,
  Text,
  VStack,
} from '@chakra-ui/react';
import { convertFromRaw } from 'draft-js';
import NextLink from 'next/link';
import * as React from 'react';

import { usePostHref } from '@/hooks/usePostHref';
import { MessageSquareIcon } from '@/imports/ui/chakra/feather';

import { SimplePostAnnouncement_SimplePostFragment } from './graphql-types/SimplePostAnnouncement_SimplePostFragment';

import { Card } from '../Card';

const POST_FRAGMENT = gql`
  fragment SimplePostAnnouncement_SimplePostFragment on SimplePost {
    _id
    simplePostTitle: title
    simplePostBody: body
  }
`;

export const SimplePost: React.FC<
  {
    simplePost: SimplePostAnnouncement_SimplePostFragment;
  } & BoxProps
> & { simplePostFragment: DocumentNode } = ({
  simplePost,
  children,
  ...rest
}) => {
  const postHref = usePostHref(simplePost._id);

  return (
    <LinkBox>
      <Card {...rest}>
        <VStack overflow="hidden" alignItems="start" spacing="0">
          <HStack>
            <MessageSquareIcon color="gray.500" />
            <Text textStyle="detail" color="gray.500" fontWeight="600">
              <LinkOverlay as={NextLink} href={postHref}>
                MESSAGE
              </LinkOverlay>
            </Text>
          </HStack>
          <Text noOfLines={2} textStyle="bodyStrong">
            {simplePost.simplePostTitle}
          </Text>
          <Text noOfLines={3} textStyle="detail">
            {simplePost.simplePostBody &&
              convertFromRaw(simplePost.simplePostBody).getPlainText()}
          </Text>
        </VStack>
      </Card>
      {children}
    </LinkBox>
  );
};
SimplePost.simplePostFragment = POST_FRAGMENT;
